import React, { useState, useRef } from "react";

const OtpInput = ({
  length = 6,
  handleOtpChange = () => {},
  label,
  inputName,
  errorType,
  errorText,
  labelParentClass = "",
  labelChildClass = "",
  enterKeyClicked = () => {},
}) => {
  const [otp, setOtp] = useState(new Array(length).fill(""));
  const inputRefs = useRef([]);
  const backspaceTimer = useRef(null);

  const handleChange = (index, event) => {
    const value = event.target.value;
    if (isNaN(value)) return;
    const newOtp = [...otp];
    newOtp[index] = value;
    setOtp(newOtp);
    // Move to the next input field
    if (event.target.nextSibling && value !== "") {
      event.target.nextSibling.focus();
    }
    handleOtpChange(newOtp.join(""));
  };

  const handlePaste = (event) => {
    event.preventDefault();
    const pastedData = event.clipboardData
      .getData("Text")
      .slice(0, length)
      .split("");
    const newOtp = [...otp];
    pastedData.forEach((data, index) => {
      if (!isNaN(data)) {
        newOtp[index] = data;
      }
    });
    setOtp(newOtp);
    handleOtpChange(newOtp.join(""));
  };

  const handleKeyDown = (index, event) => {
    if (event.key === "Backspace") {
      event.preventDefault();
      const newOtp = [...otp];

      if (otp[index]) {
        newOtp[index] = "";
        setOtp(newOtp);
        handleOtpChange(newOtp.join(""));
      } else if (index > 0) {
        inputRefs.current[index - 1].focus();
        newOtp[index - 1] = "";
        setOtp(newOtp);
        handleOtpChange(newOtp.join(""));
      }
    }

    if (event.key === "Enter") {
      enterKeyClicked();
    }
  };

  return (
    <>
      {label && (
        <div className={`label relative ${labelParentClass}`}>
          <h2 className={`font-bold text-lg text-center ${labelChildClass}`}>
            {label}
          </h2>
        </div>
      )}

      <div>
        <div className="flex justify-center items-center">
          {otp.map((digit, index) => (
            <input
              key={index}
              name={inputName}
              ref={(el) => (inputRefs.current[index] = el)}
              type="text"
              maxLength="1"
              value={digit}
              onChange={(e) => handleChange(index, e)}
              onKeyDown={(e) => handleKeyDown(index, e)}
              onPaste={handlePaste}
              className="w-12 h-12 mx-1 text-center border rounded-md text-primary border-primary font-bold"
              style={{ fontVariantNumeric: "tabular-nums" }}
            />
          ))}
        </div>
        {errorType && errorType === "error" && (
          <div className="text-xs text-red-600 mt-1">
            <i className="fa-regular fa-fw fa-square-exclamation text-sm mr-1"></i>
            {errorText}
          </div>
        )}
        {errorType && errorType === "warning" && (
          <div className="text-xs text-amber-600 mt-1">
            <i className="fa-regular fa-fw fa-triangle-exclamation text-sm mr-1"></i>
            {errorText}
          </div>
        )}
        {errorType && errorType === "success" && (
          <div className="text-xs text-green-600 mt-1">
            <i className="fa-regular fa-fw fa-circle-check text-sm mr-1"></i>
            {errorText}
          </div>
        )}
        {errorType && errorType === "info" && (
          <div className="text-xs text-sky-600 mt-1">
            <i className="fa-regular fa-fw fa-circle-info text-sm mr-1"></i>
            {errorText}
          </div>
        )}
      </div>
    </>
  );
};

export default OtpInput;
